<div class="modal fade"
  #abc
  [id]="modalId"
  role="dialog"
  aria-label="close"
  style="display: block;"
>
  <div class="modal-dialog" [ngStyle]="modalStyles">
    <div class="uil-dialog-card x-overflow-hidden" [ngStyle]="dialogStyles">
   
      <div id="modal_content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
